import { createAction, handleActions, Reducer } from 'redux-actions';
import { PartnerAdAccountsCount } from '@api/types';
import { SelectorState } from '@redux/types';

export interface PartnerAdAccountsState {
  isLoading: boolean;
  counts: PartnerAdAccountsCount;
}

export const initialState: PartnerAdAccountsState = {
  isLoading: false,
  counts: { twitter: 0, facebook: 0, google: 0 },
};

type PartnerAdAccountsReducer<T = PartnerAdAccountsState> = Reducer<PartnerAdAccountsState, T>;

// Actions

const AD_ACCOUNTS_COUNTS_FETCH_STARTED = 'partnerAdAccounts/AD_ACCOUNTS_COUNTS_FETCH_STARTED';
const AD_ACCOUNTS_COUNTS_FETCH_SUCCEED = 'partnerAdAccounts/AD_ACCOUNTS_COUNTS_FETCH_SUCCEED';

// Action creators

export const fetchPartnerAdAccountsCounts = createAction(AD_ACCOUNTS_COUNTS_FETCH_STARTED);
export const fetchPartnerAdAccountsCountsSucceed = createAction<PartnerAdAccountsCount>(
  AD_ACCOUNTS_COUNTS_FETCH_SUCCEED,
);

// Reducers

const handleFetchAdAccount: PartnerAdAccountsReducer = state => ({
  ...state,
  isLoading: true,
});

const handleFetchAdAccountSucceed: PartnerAdAccountsReducer<PartnerAdAccountsCount> = (state, { payload }) => ({
  ...state,
  isLoading: false,
  counts: payload,
});

export default handleActions<PartnerAdAccountsState, any>(
  {
    [AD_ACCOUNTS_COUNTS_FETCH_STARTED]: handleFetchAdAccount,
    [AD_ACCOUNTS_COUNTS_FETCH_SUCCEED]: handleFetchAdAccountSucceed,
  },
  initialState,
);

// Selectors

export const getPartnerAdAccountsState: SelectorState<PartnerAdAccountsState> = state => state.partnerAdAccounts;
